"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const splide_1 = __importDefault(require("@splidejs/splide"));
require("@splidejs/splide/src/css/core/index.scss");
require("@splidejs/splide/src/css/template/default/index.scss");
require("@splidejs/splide/src/css/themes/default/index.scss");
require("../scss/Timeline.scss");
const localize_1 = require("./modules/localize");
const timelineSlider = Array.from(document.querySelectorAll('.js-gs1-timeline-slider'));
document.addEventListener('DOMContentLoaded', () => {
    if (timelineSlider) {
        timelineSlider.forEach((timeline) => {
            let timelineSlider = new splide_1.default(timeline, {
                type: 'slide',
                rewind: false,
                width: '100%',
                height: 'max-content',
                start: 0,
                perPage: 1,
                arrows: true,
                pagination: false,
                autoplay: true,
                pauseOnHover: true,
                pauseOnFocus: true,
                lazyLoad: 'nearby',
                preloadPages: 2,
                keyboard: true,
                direction: 'ltr',
                breakpoints: {
                    480: {
                        perPage: 1,
                        height: 'max-content',
                    },
                },
                i18n: {
                    'prev': `${(0, localize_1.Localize)('element.label.timeline.prev', 'Previous')}`,
                    'next': `${(0, localize_1.Localize)('element.label.timeline.next', 'Next')}`,
                    'first': `${(0, localize_1.Localize)('element.label.timeline.first', 'First')}`,
                    'last': `${(0, localize_1.Localize)('element.label.timeline.last', 'Last')}`,
                    'slideX': `${(0, localize_1.Localize)('element.label.timeline.slideX', 'Slide')}`,
                    'pageX': `${(0, localize_1.Localize)('element.label.timeline.pageX', 'Page')}`,
                    'play': `${(0, localize_1.Localize)('element.label.timeline.play', 'Play')}`,
                    'pause': `${(0, localize_1.Localize)('element.label.timeline.pause', 'Pause')}`,
                    'carousel': `${(0, localize_1.Localize)('element.label.timeline.carousel', 'Carousel')}`,
                    'select': `${(0, localize_1.Localize)('element.label.timeline.select', 'Select to show')}`,
                    'slide': `${(0, localize_1.Localize)('element.label.timeline.slide', 'Slide')}`,
                    'slideLabel': `${(0, localize_1.Localize)('element.label.timeline.slideLabel', 'Slide %s of %s')}`,
                }
            });
            let timelineImageSlider = new splide_1.default('.js-gs1-timeline-image-slider', {
                arrows: false,
                cover: true,
                clones: 0,
                drag: false,
                fixedWidth: 68,
                fixedHeight: 68,
                flickPower: 600,
                flickMaxPages: 1,
                focus: 2,
                height: 218,
                isNavigation: true,
                pagination: false,
                perMove: 1,
                perPage: 1,
                rewind: false,
                trimSpace: true,
                waitForTransition: true,
                wheel: true,
                i18n: {
                    'prev': `${(0, localize_1.Localize)('element.label.timeline.prev', 'Previous')}`,
                    'next': `${(0, localize_1.Localize)('element.label.timeline.next', 'Next')}`,
                    'first': `${(0, localize_1.Localize)('element.label.timeline.first', 'First')}`,
                    'last': `${(0, localize_1.Localize)('element.label.timeline.last', 'Last')}`,
                    'slideX': `${(0, localize_1.Localize)('element.label.timeline.slideX', 'Slide')}`,
                    'pageX': `${(0, localize_1.Localize)('element.label.timeline.pageX', 'Page')}`,
                    'play': `${(0, localize_1.Localize)('element.label.timeline.play', 'Play')}`,
                    'pause': `${(0, localize_1.Localize)('element.label.timeline.pause', 'Pause')}`,
                    'carousel': `${(0, localize_1.Localize)('element.label.timeline.carousel', 'Carousel')}`,
                    'select': `${(0, localize_1.Localize)('element.label.timeline.select', 'Select to show')}`,
                    'slide': `${(0, localize_1.Localize)('element.label.timeline.slide', 'Slide')}`,
                    'slideLabel': `${(0, localize_1.Localize)('element.label.timeline.slideLabel', 'Slide %s of %s')}`,
                }
            });
            timelineSlider.sync(timelineImageSlider);
            timelineSlider.mount();
            timelineImageSlider.mount();
        });
    }
});
